<template>
  <div class="container">
    <div class="row justify-content-center align-items-center mh-100vh">
      <div class="col-lg-5 col-md-8">
        <div class="card pl-2 text-white main-color mb-1">
          <div class="card-body h2">
            {{this.config.projectName}}
          </div>
        </div>
        <div class="card-group">
          <div class="card p-4">
            <b-overlay :show="overlayShow" rounded="sm">
              <div class="card-body">
                <div class="input-group mb-3">
                <span>届いた認証番号を入力してください</span>
                </div>
                <div class="input-group">
                  <input class="form-control" type="text" v-model="oneTimePassword" :class="{'is-invalid' : validation.hasError('oneTimePassword')}" autocomplete="off">
                  <div class="invalid-feedback">{{ validation.firstError('oneTimePassword') }}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-12">
                    <b-button block variant="primary" @click.stop.prevent="confirm()">確認</b-button>
                  </div>
                </div>
              </div>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import MeetingStartModel from '@/models/MeetingStartModel'
import SimpleVueValidation from 'simple-vue-validator'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'CustomerSNSAuth',
  components: {MeetingStartModel},
  data () {
    return {
      overlayShow: false,
      oneTimePassword: ''
    }
  },
  validators: {
    oneTimePassword: function (value) { return Validator.value(value).required(this.consts.validationMsg.SMSAuth.oneTimePassword.required) }
  },
  methods: {
    confirm: async function () {
      let isError = await this.$validate()
        .then((success) => {
          return !success
        })

      if (isError) {
        return false
      }

      const params = {'oneTimePassword': this.oneTimePassword, 'attendeeType': this.consts.attendeeType.customer}

      this.overlayShow = true
      const meetingStartModel = await MeetingStartModel.apiSetStore(this.$bvModal, params, () => {
        this.overlayShow = false
      })
      sessionStorage.meeting = await JSON.stringify(meetingStartModel.meeting)
      sessionStorage.attendee = await JSON.stringify(meetingStartModel.attendee)
      this.$router.push('/customer/meeting/agenda')
    }
  },
  destroyed () {
    if (MeetingStartModel.getStore()) {
      MeetingStartModel.removeStore()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CustomerSNSAuth.vue